import { EnrichedFundDetails } from '../../types';
import BigNumber from 'big.js';
import { API } from '@xbto/api-client';
import { BigOrZero } from '../big';

export function enrichFundDetails(
  fundDetails: API.FundBalanceDetailDto | null,
  isAccountOfTypeFund: boolean
): EnrichedFundDetails | null {
  if (!fundDetails) {
    return null;
  }

  return {
    ...fundDetails,
    isRedeemed: isAccountOfTypeFund
      ? BigOrZero(fundDetails.valueInSecondaryAsset).lte(0)
      : false,
    totalInvested: fundDetails.totalInvested
      ? BigNumber(fundDetails.totalInvested)
      : null,
    totalInvestedUsd: fundDetails.totalInvestedUsd
      ? BigNumber(fundDetails.totalInvestedUsd)
      : null,
  };
}
